<script lang="ts">
    import { onMount } from 'svelte';
    import PageHeader from '../components/PageHeader.svelte';
    import TileEnterprise from '../components/TileEnterprise.svelte';
    import TileMember from '../components/TileMember.svelte';
    import { storeWorksite } from "../scripts/worksite";
    import { storeLanguage, lang_fr } from "../scripts/store";
    import TileDeliverable from '../components/TileDeliverable.svelte';

    onMount(async () => {
        window.scrollTo(0,0);
	});

</script>
    
<style lang="scss">

    .chantier {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        &__bloc {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
        }
        &__subtitle {
            margin: 50px 0 0 0;
        }
        &__leaders {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
            margin: 20px 0 0 0;
            width: 100%;
        }
        &__deliverables {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
            margin: 20px 0 0 0;
            width: 100%;
        }
        &__goals {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
            margin: 20px 0 0 0;
            width: 100%;
        }
        &__participants {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
            margin: 20px 0 0 0;
            width: 100%;
        }
    }

    @include large {
        .chantier {
            &__bloc {
                align-items: flex-start;
            }
            &__leaders {
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                flex-wrap: wrap;
            }
            &__deliverables {
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                flex-wrap: wrap;
            }
            &__goals {
                flex-direction: row;
                align-items: center;
                justify-content: flex-start;
            }
            &__participants {
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                flex-wrap: wrap;
            }
        }
    }

</style>

<div class="chantier">
    {#if ($storeLanguage == $lang_fr)}
    <PageHeader props={$storeWorksite.title_fr}/>
    {:else}
    <PageHeader props={$storeWorksite.title_en}/>
    {/if}
    <div class="bloc chantier__bloc">
        <div class="chantier__subtitle font__h2">
            {#if ($storeLanguage == $lang_fr)}
                {#if ($storeWorksite.leaders.length == 1)}
                Leader
                {:else}
                Les leaders
                {/if}
            {:else}
                {#if ($storeWorksite.leaders.length == 1)}
                Leader
                {:else}
                The leaders
                {/if}
            {/if}
        </div>
        <div class="chantier__subtitle chantier__leaders">
            {#each $storeWorksite.leaders as leader}
                <TileMember propsUser={leader} propsDisplayEnterprise={false}/>
            {/each}
        </div>
        {#if ($storeWorksite.deliverables != undefined && $storeWorksite.deliverables.length > 0)}
        <div class="chantier__subtitle font__h2">
            {#if ($storeLanguage == $lang_fr)}
            Les supports
            {:else}
            The supports
            {/if}
        </div>
        <div class="chantier__deliverables">
            {#each $storeWorksite.deliverables as deliverable}
                <TileDeliverable props={deliverable}/>
            {/each}
        </div>
        {/if}
        <div class="chantier__subtitle font__h2">
            {#if ($storeLanguage == $lang_fr)}
            Les objectifs
            {:else}
            The objectives
            {/if}
        </div>
        <div class="chantier__goals">
            <ul>
                {#each $storeWorksite.goals as goal}
                <li>
                    {#if ($storeLanguage == $lang_fr)}
                    {goal.label_fr}
                    {:else}
                    {goal.label_en}
                    {/if}
                </li>
            {/each}
            </ul>
        </div>
        <div class="chantier__subtitle font__h2">
            {#if ($storeLanguage == $lang_fr)}
            Les participants
            {:else}
            The participants
            {/if}
        </div>
        <div class="chantier__participants">
            {#each $storeWorksite.participants as participant}
                <TileEnterprise props={participant}/>
            {/each}
        </div>
    </div>
</div>
